import './CycoPage.less';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import OneColumnLayout from '../../../../framework/components/Templates/OneColumnLayout/OneColumnLayout';
import BodyHeader from '../../../../shared-components/BodyHeader/BodyHeader';
import CycoPageForm from './CycoPageForm';

export class CycoPage extends Component {
    static propTypes = {
        onComponentDidMount: PropTypes.func.isRequired
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    render() {
        return (
            <OneColumnLayout pageName={'CycoPage CycoPage--ni CycoPage--acquisition'}>
                <BodyHeader />
                <CycoPageForm />
            </OneColumnLayout>
        );
    }
}

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_cycopage', 'prepare_pp_credit_cycopage'));
    }
});

export default connect(undefined, mapDispatchToProps)(CycoPage);
